import {PlayerColor} from '@colonist/game-states'
import {type ImageURL} from '@colonist/types'
import KnightLevel1ActiveRed from '@static/images/knight_level1_active_red.svg'
import KnightLevel1ActiveBlue from '@static/images/knight_level1_active_blue.svg'
import KnightLevel1ActiveOrange from '@static/images/knight_level1_active_orange.svg'
import KnightLevel1ActiveGreen from '@static/images/knight_level1_active_green.svg'
import KnightLevel1ActiveBlack from '@static/images/knight_level1_active_black.svg'
import KnightLevel1ActiveBronze from '@static/images/knight_level1_active_bronze.svg'
import KnightLevel1ActiveSilver from '@static/images/knight_level1_active_silver.svg'
import KnightLevel1ActiveGold from '@static/images/knight_level1_active_gold.svg'
import KnightLevel1ActiveWhite from '@static/images/knight_level1_active_white.svg'
import KnightLevel1ActivePurple from '@static/images/knight_level1_active_purple.svg'
import KnightLevel1ActiveMysticBlue from '@static/images/knight_level1_active_mysticblue.svg'
import KnightLevel1ActivePink from '@static/images/knight_level1_active_pink.svg'

export const KNIGHT_ACTIVATION_IMAGE_PATH: Record<PlayerColor, ImageURL> = {
    [PlayerColor.None]: '' as ImageURL,
    [PlayerColor.Red]: KnightLevel1ActiveRed,
    [PlayerColor.Blue]: KnightLevel1ActiveBlue,
    [PlayerColor.Orange]: KnightLevel1ActiveOrange,
    [PlayerColor.Green]: KnightLevel1ActiveGreen,
    [PlayerColor.Black]: KnightLevel1ActiveBlack,
    [PlayerColor.Bronze]: KnightLevel1ActiveBronze,
    [PlayerColor.Silver]: KnightLevel1ActiveSilver,
    [PlayerColor.Gold]: KnightLevel1ActiveGold,
    [PlayerColor.White]: KnightLevel1ActiveWhite,
    [PlayerColor.Purple]: KnightLevel1ActivePurple,
    [PlayerColor.MysticBlue]: KnightLevel1ActiveMysticBlue,
    [PlayerColor.Pink]: KnightLevel1ActivePink,
}
